import { setTerm } from './helpers';

export const setWithoutAgentsCalls = setTerm('cl');
